import WaterDropIcon from '@mui/icons-material/WaterDrop';
import React from 'react';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';

const COUNTER_OPTION_MAP = {
  'counter:water:cold': { color: '#359BFF', icon: WaterDropIcon },
  'counter:water:hot': { color: '#FC3339', icon: WaterDropIcon },
  'counter:water': { color: '#6B7280', icon: WaterDropIcon },
  'sensor:water:leakage': { color: '#6B7280', icon: ToggleOnOutlinedIcon },
};

const CounterIcon = ({ type }) => {
  const selectCounter = COUNTER_OPTION_MAP[type] ?? COUNTER_OPTION_MAP['counter:water'];
  const Icon = selectCounter.icon;

  return (
    <div style={{ backgroundColor: selectCounter.color }} className={`flex items-center justify-center rounded-full w-10 h-10`}>
      <Icon className="text-white" />
    </div>
  );
};
export default CounterIcon;
